
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-skills',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
})
export class SkillsComponent implements OnInit {
  skills: any = {};
  skillKeys: string[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadSkills();

    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadSkills();
    });
  }

  private loadSkills(): void {
    this.translate.get('skills').subscribe((data) => {
      this.skills = data;
      this.skillKeys = Object.keys(data).filter((key) => key !== 'title');
    });
  }

  getIconClass(key: string): string {
    switch (key) {
      case 'frontEnd':
        return 'fas fa-code';
      case 'backEnd':
        return 'fas fa-server';
      case 'database':
        return 'fas fa-database';
      case 'devOpsAndTools':
        return 'fas fa-tools';
      default:
        return '';
    }
  }

}

